//basic
import React, { Component } from 'react';
import { observer, inject } from "mobx-react";
import { toJS } from 'mobx';

//style
import '../AddTopProduct/AddTopProduct.scss';

//api
import { api } from '../../../functions/api';

//custom components
import CustomButton from "../../../components/basic/CustomButton";
import SelectSearch  from '../../../components/basic/SelectSearch/SelectSearch';

//material-ui
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    CircularProgress
} from "@material-ui/core";

//other libraries


@inject("translate")
@inject("internal")
@observer
export default class AddTopProduct extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            selectedRow: "",
            loading: true,
            shop_id: this.props.shop,
            loadingBtn: false,
        }
    }

    componentDidMount() {

         // let listAllProducts = load_products.data.data //pomocna premena kde ukladam data, potrebujem premenovat na value/label
         let listAllProducts = toJS(this.props.internal.dataForTable.lists.products) //pomocna premena kde ukladam data, potrebujem premenovat na value/label
         let newListProducts = []

        let topProducts = toJS(this.props.internal.dataForTable.data)

        let filtered = []
        let isUsed = false // pouziva sa na kontorlu ci je produkt v top produktoch

        for(let product in listAllProducts) {
            for(let top in topProducts) {
                if(topProducts[top].product_id === listAllProducts[product].id) {
                    isUsed = true
                }
            }

            if(!isUsed) {
                filtered.push(listAllProducts[product])
            }

            isUsed = false
        }
       
        for(let product in filtered) {
            newListProducts.push({
                value: filtered[product].id,
                label: filtered[product].name
            })
        }
        this.props.internal.setAllProducts(newListProducts);
        this.setState({data: newListProducts, loading: false})
    }

    

    onAddTopProduct = (val) => {
        this.setState({selectedRow: val})
    }

    action = async() => {
        this.setState({loadingBtn: true})
        //products/top/toggle

        let update_data = await api({
            method: 'patch',
            url: "products/top/toggle",
            authorization: this.props.internal.user.access_token,
            params: {
                product_id: this.state.selectedRow.value,
                // is_top: true,
                shop_id: this.state.shop_id
            }
        })

        if(update_data.success === true) {
            this.setState({loadingBtn: false})
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.SUCCESS_UPDATE, true)
            this.props.onClose()
        }
    }

    render () {
        return (
            <Dialog
                open={this.props.open}
                onClose={this.props.onClose}
                aria-labelledby="form-dialog-title"
                classes={{
                    root: "add-top-product",
                    paper: "addTopProductDialog"
                }}
            >
                <DialogTitle id="form-dialog-title">
                    {this.props.title}
                </DialogTitle>
                {this.state.loading
                ?
                <div style={{minHeight: "100px"}}>
                    <CircularProgress className={'circular-progress'} />
                </div>
                :
                <DialogContent classes={{root: "add-top-product-content"}}>
                    <SelectSearch
                        options={this.state.data}
                        // onChange={this.onParentSelectChange}
                        onChange={val => this.onAddTopProduct(val)}
                        value={this.state.selectedRow}
                        className={'select-search'}
                        label={this.props.translate.i18n.MODULES['TOP-PRODUCTS'].PRODUCTS}
                    />
                </DialogContent>
                }
                <DialogActions>
                    <Button
                        onClick={this.props.onClose}
                        className={"gray-text"}
                    >
                        {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                    </Button>
                    <CustomButton
                        progressBar={this.state.loadingBtn}
                        onClick={this.action}
                        mystyle={"btn-white-bg"}
                        title={this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                        justText
                        disabled={this.state.loading}
                    />
                </DialogActions>
            </Dialog>
        )
    }
}



// WEBPACK FOOTER //
// ./src/screens/topProducts/AddTopProduct/AddTopProduct.jsx